import { useMemo } from 'react';

export const useURLHash = (name: string) => {
  const { hash } = window.location;
  return useMemo(() => hash.replace(`#${name}=`, ''), [hash]);
};
